module.exports = __webpack_public_path__ + "img/convoys.edab92cd.jpg";